import { Injectable } from '@angular/core';
import { DataEntityExportTemplate } from '@osos/shared/api';
import { DataEntityTemplatePresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { DataEntityTemplateParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable()
export class DataEntityTemplateFactoryService extends FactoryBase<
  DataEntityExportTemplate,
  DataEntityTemplatePresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataEntityTemplateParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: DataEntityTemplatePresenterModel,
  ): DataEntityExportTemplate {
    //@TODO use presenter.specificationVersion
    const parser = this.getParser(
      DataEntityExportTemplate,
      DataEntityTemplatePresenterModel,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: DataEntityExportTemplate,
  ): DataEntityTemplatePresenterModel {
    //@TODO use model.specificationVersion
    const parser = this.getParser(
      DataEntityExportTemplate,
      DataEntityTemplatePresenterModel,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
